import styled from 'styled-components'

export const StyledHostApprovalImageAccessibilityTriggerText = styled.p`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
